import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/styles/withStyles';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import InputAdornment from '@material-ui/core/InputAdornment';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
import { CALENDAR_BLACK_OUTLINE_ICON, OUTLINED_CALENDAR_ICON } from '@Images';

const styles = () => ({
  '@global': {
    '.MuiFormControl-root': {
      width: '100%'
    },
    '.MuiFormControl-marginNormal': {
      marginTop: '7px',
      marginBottom: '7px',
      width: '100%',
      marginLeft: '6px'
    },
    '.MuiOutlinedInput-inputAdornedEnd': {
      color: `${COLORS.black}`
    },
    '.MuiPickersToolbar-toolbar': {
      backgroundColor: `${COLORS.black}`
    },
    '.MuiPickersDay-daySelected': {
      backgroundColor: `${COLORS.black}`
    },
    '.MuiButton-textPrimary': {
      color: `${COLORS.black}`
    },
    '.MuiFormLabel-root.Mui-focused': {
      color: `${COLORS.black}`
    },
    '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${COLORS.black}`
    }
  },
  input: {
    WebkitTextFillColor: COLORS.materialUiTextFieldColor,
    height: '50px',
    color: COLORS.materialUiTextFieldColor,
    fontSize: '18px',
    caretColor: '#FE0095',
    fontFamily: FONT_FAMILY.hellix.regular
  },
  inputDisabled: {
    WebkitTextFillColor: '#a4a5b1',
    height: '50px',
    color: COLORS.materialUiTextFieldColor,
    fontSize: '16px'
  }
});
class RenderMiDatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = { is_focus: false, date: null };
    this.datePickerRef = React.createRef();
  }

  isValidDate = (str) => {
    const d = moment(str);
    if (d == null || !d.isValid()) return false;
    else return true;
  };

  updateValue = () => {
    const {
      input: { value }
    } = this.props;
    if (value) {
      const date = moment(
        value,
        this.props?.countryCode === 'US' ? 'MM/DD/YYYY' : 'DD/MM/YYYY'
      ).toDate();
      this.handleChangeRaw(date);
    }
  };

  updateValueToBlank = () => {
    this.setState({ date: null });
  };

  componentDidMount = () => {
    this.updateValue();
  };
  componentDidUpdate = (prevProps) => {
    if (prevProps.input.value !== this.props.input.value) {
      this.updateValue();
    }
    if (prevProps.input.value && this.props.input.value === '') {
      this.updateValueToBlank();
    }
  };

  handleDateChange = (date) => {
    this.setState({ date });
  };

  inputFocus = () => {
    this.setState({ is_focus: true });
  };

  inputBlur = () => {
    this.setState({ is_focus: false });
  };

  handleChangeRaw = (date) => {
    this.setState({ date: date });
    const dateVal = moment(date).format(
      this.props?.countryCode === 'US' ? 'MM/DD/YYYY' : 'DD/MM/YYYY'
    );

    this.props.input.onChange(dateVal);
  };

  render() {
    const {
      input,
      placeholder,
      maxDate,
      minDate,
      customPlaceholder = '',
      InputLabelProps,
      meta: { touched, error },
      showCalendarIcon = false,
      disableWeekends = false,
      countryCode,
      isBlackIcon = false,
      margin = 'normal'
    } = this.props;

    const disabled = this.props.disabled || false;
    const { classes } = this.props;
    this.id = this.props.id ? this.props.id.replace('_', '-') : input.name.replace('_', '-');

    const isWeekend = (date) => {
      const day = date.getDay();
      return day === 0 || day === 6;
    };

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DatePicker
          label={placeholder}
          InputProps={{
            className: disabled ? classes.inputDisabled : classes.input,
            endAdornment: showCalendarIcon && (
              <InputAdornment position="end">
                <img
                  src={isBlackIcon ? CALENDAR_BLACK_OUTLINE_ICON : OUTLINED_CALENDAR_ICON}
                  alt="icon"
                />
              </InputAdornment>
            )
          }}
          inputVariant="outlined"
          format={countryCode === 'US' ? 'MM/dd/yyyy' : 'dd/MM/yyyy'}
          margin={margin}
          {...input}
          id={this.id}
          value={this.state.date}
          error={!this.state.date && touched && error}
          ref={this.datePickerRef}
          onChange={this.handleChangeRaw}
          animateYearScrolling
          helperText={!this.state.date && touched && error}
          disabled={disabled}
          className={this.props.parentClassName}
          minDate={minDate}
          maxDate={maxDate}
          InputLabelProps={InputLabelProps}
          placeholder={customPlaceholder}
          shouldDisableDate={disableWeekends && isWeekend}
        />
      </MuiPickersUtilsProvider>
    );
  }
}

RenderMiDatePicker.propTypes = {
  id: PropTypes.string,
  input: PropTypes.any,
  placeholder: PropTypes.string,
  meta: PropTypes.any,
  className: PropTypes.string,
  isTimePicker: PropTypes.bool,
  maxDate: PropTypes.any,
  minDate: PropTypes.any,
  onlyWeekDays: PropTypes.bool,

  disabled: PropTypes.bool,
  excludeDates: PropTypes.array,
  classes: PropTypes.object.isRequired,
  classId: PropTypes.string,
  parentClassName: PropTypes.string,
  formatString: PropTypes.string,
  InputLabelProps: PropTypes.any,
  customPlaceholder: PropTypes.string,
  showCalendarIcon: PropTypes.bool,
  disableWeekends: PropTypes.bool,
  countryCode: PropTypes.string,
  isBlackIcon: PropTypes.bool,
  margin: PropTypes.string
};

const translateDatePicker = RenderMiDatePicker;

export default withStyles(styles)(translateDatePicker);
